/**
 * @generated SignedSource<<d6d063faf87af988aad5201e018b8f14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineNavigationListItem_Routine$data = {
  readonly title: string;
  readonly " $fragmentType": "RoutineNavigationListItem_Routine";
};
export type RoutineNavigationListItem_Routine$key = {
  readonly " $data"?: RoutineNavigationListItem_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineNavigationListItem_Routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineNavigationListItem_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "16adbbc106ffe1f9c00b26eb1c4aefca";

export default node;
